<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <div class="section white-panel mb2p pt24">
          <p class="fs14 font-weight-bold">登録情報は削除されました。</p>
          <p class="fs13 mb48">SS登録画面へ移ります。</p>
          <button class="button fs16 mb24 mt24 w85p" v-on:click="moveToSsSelect()">SS登録画面へ</button>
        </div>
      </article>
    </div>
  </div>
</template>

<script>

// ネイティブの関数(deleteAccount)のパラメータに
// "1" を渡すと、SS選択画面に遷移する
const moveSsSelectNativeParam = '1'

export default {
  methods: {
    moveToSsSelect () {
      this.nativeEVENTSet('MypageAccountDeleteCompleteTopButton', 'DELETECOMPLETE', 'TAP')
      if ('Android' in window) {
        Android.deleteAccount('1')
      } else if ('webkit' in window) {
        webkit.messageHandlers.deleteAccount.postMessage(moveSsSelectNativeParam)
      }
    }
  },
  mounted () {
    // [eventTrack] 削除完了画面
    this.nativePVset('MYPAGE_ACCONUTDELETECOMPLETE')
  }
}
</script>
